import { ICacheSetting, ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { CACHE_SETTINGS_SEARCH_TERMS, ConfigCacheSettings } from "./app-settings-config-cache";

export interface IConfigCacheInputState {
  showModal: boolean;
  editingCacheId: string;
}

export interface IConfigCacheInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigCacheInput extends PureComponent<IConfigCacheInputProps, IConfigCacheInputState> {
  formInputName = ["apiConfig", "cacheSettingsId"];

  constructor(props: IConfigCacheInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingCacheId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingCacheId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingCacheId: id, showModal: true });
  };

  render() {
    const options = [
      { id: null, name: "Default" } as unknown as ICacheSetting,
      ...(this.props.commonSettings.cacheSettings || [])
    ];
    return (
      <>
        <ConfigCacheSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingCacheId={this.state.editingCacheId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          searchTerms={CACHE_SETTINGS_SEARCH_TERMS}
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="appsettings_cachesettings_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          dropdownTestId="appSettingsCacheDropdown"
          addNewTestId="appSettingsCacheAddNewButton"
          editTestId="appSettingsCacheEditButton"
        />
      </>
    );
  }
}
